import webcall from '@/libs/webcall';
import store from '@/store';
import versionReporter from './versionReporter';

const LOG_LEVEL = {
  OFF: 0,
  WARN: 1,
  ERROR: 2,
  ALL: 3,
};

const TRACKER_TYPE = {
  error: 'error',
  usage: 'usage',
};

const track = (trackerType, message, data) => {
  // TODO: Check and make sure that user as internet access.
  // If no internet, queue tracker into localStorage, to be sent when he next open the page
  // If yes, send tracker directly

  if (!navigator.onLine) return null; // TODO: Is not online, don't track now, otherwise a infinite loop will happen;

  const tracker = {
    activity_type: `${'creator_'}${trackerType}`,
    product: 'creator',
    user_agent: navigator.userAgent,
    user_id: (store.state.account.blob) ? store.state.account.blob.id : false,
    params: JSON.stringify({
      message,
      debug: {
        version: versionReporter.version,
        path: window.location.href,
        store: {
          layout: store.state.layout,
          uploadQueue: store.state.uploadQueue,
          submission: Object.keys(store.state.submission),
        },
        window: {
          x: innerHeight,
          y: innerWidth,
        },
      },
      ...data,
    }),
  };

  return webcall.support.log(tracker);
};

export default {
  logLevel: (process.env.NODE_ENV === 'production') ? LOG_LEVEL.OFF : LOG_LEVEL.ALL,
  warn(message) {
    /* eslint no-console: 0 */
    console.warn(message);
  },
  error(message) {
    /* eslint no-console: 0 */
    console.error(message);
  },
  errorHandler(error, vm, info) {
    track(TRACKER_TYPE.error, info, {
      error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
    });

    throw error;
  },
  track: {
    error(title, message, data) {
      return track(TRACKER_TYPE.error, message, data);
    },
    info(title, message, data) {
      return track(TRACKER_TYPE.info, message, data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/debugLogger.js